import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import Icons from '../../../src/components/icons';
import { HeartFillIcon } from '@primer/octicons-react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Primer Octicons are GitHub’s open source library of icons for GitHub UI. These are visual metaphors intended to serve as a visual language. If you are looking for brand and marketing logos and visuals, see `}<a href="/foundations/icons/octovisuals">{`Octovisuals`}</a>{`.`}</p>
    <a href="/foundations/icons/design-guidelines">See Design and usage guidelines</a>
    <br />
    <br />
    <Icons mdxType="Icons" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      